import BaseComponent from '../BaseComponentMixin.jsx';
import methods from '../../../Shared/methods';
import utils from '../../../Shared/utils.jsx';

export default {
    name: 'DropdownMultiSelectBase',
    data: function () {
        return {
            uniqueref: null,
            emptySelected: false,
        }
    },
    props: {
        source: {
            type: Array,
            default: () => []
        },
        ccmodel: null,
        nameField: null,
        valueField: null,
        placeholder: {
            type: String,
            default: ''
        },
        selectionLimit: {
            type: Number,
            default: 0
        },
        showCheckAll: {
            type: Boolean,
            default: true
        },
        showUncheckAll: {
            type: Boolean,
            default: true
        },
        dynamicButtonText: {
            type: Boolean,
            default: false
        },
        dynamicItemCount: {
            type: Number,
            default: 0
        },
        hint: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        hideLabelSlot: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: Boolean,
            default: true
        },
        includeEmpty: {
            type: Boolean,
            default: false,
        },
        emptyLabel: {
            type: String,
            default: '',
        },
        initialEmptyValue: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
            default: () => []
        },
        errorMessages: {
            type: Array,
            default: () => []
        },
        error: {
            type: Boolean,
            default: false,
        }
    },
    created() {
        this.uniqueref = utils.generateUUID();
        this.emptySelected = this.initialEmptyValue;
    },
    computed: {
        allSelected() {
            let res = (this.ccmodel?.length === this.source.length && (!this.includeEmpty || this.emptySelected)) ||
                (this.selectionLimit > 0 && this.ccmodel?.length === this.selectionLimit) ||
                (this.$refs && this.$refs[this.uniqueref]?.filteredItems?.length == this.ccmodel?.length && (!this.includeEmpty || this.emptySelected));

            console.log(`DropdownMultiSelect ${this.$parent.name} reading allSelected; ccmodel:${this.ccmodel?.length}; source:${this.source.length}; emptySelected:${!this.includeEmpty || this.emptySelected}; selectionLimit:${this.selectionLimit}; filteredItems:${this.$refs[this.uniqueref]?.filteredItems?.length}; res:${res}`);

            return res;
        },
        someSelected() {
            return (this.ccmodel?.length > 0 || this.emptySelected) && !this.allSelected;
        },
        selectAllIcon() {
            if (this.allSelected) return 'mdi-close-box'
            if (this.someSelected) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        localModel() {
            if (this.ccmodel && !Array.isArray(this.ccmodel))
                return [this.ccmodel];
            return this.ccmodel;
        }
    },
    //Created Replaced with preRenderComplete
    methods: {
        ...methods,
        async onInput(item) {
            let value = null;
            // A selection limit of 0 is meant to mean unlimited length, and a selection limit of 1 will emit a 
            // single item. We want to pop the last item off of the array if it violates the selection limit 
            if (Array.isArray(item) && this.selectionLimit != 0 && item.length > this.selectionLimit)
                item.pop();
            if (!Array.isArray(item))
                value = [item];
            else
                value = item;

            if (!value)
                value = [];

            if (Array.isArray(value) && value.length == 0 && this.emptySelected)
                this.emptySelected = false;

            this.$emit('input', value);
        },
        async toggleAll() {
            this.$nextTick(() => {
                let value = null;
                if (this.allSelected) {
                    value = [];

                    this.emptySelected = false;
                }
                else {
                    value = this.$refs[this.uniqueref].filteredItems.map(x => {
                        return this.getNameOrValue(this.valueField, x);
                    }).slice(0, this.selectionLimit > 0 ? this.selectionLimit : undefined);

                    this.emptySelected = true;
                }
                this.$emit('input', value);
                this.$emit('empty', this.emptySelected);
            });
        },
        getNameOrValue(valueField, sourceObject) {
            if (typeof valueField === 'string')
                return sourceObject[valueField];
            else if (typeof valueField === 'function')
                return valueField(sourceObject);
            else
                return sourceObject;
        }
    },
    render(h) {
        try {
            let scopedSlots = {
                selection: ({ item, index, parent }) => {
                    // We can really only show information about the selected items if they are strings. Otherwise we can only show that there 
                    // are a certain number selected.
                    let content = null;
                    if (this.dynamicButtonText && typeof this.getNameOrValue(this.nameField, item) === 'string') {
                        let isLastIndex = index + 1 == this.localModel.length || index + 1 == this.dynamicItemCount;
                        let extraCount = Math.max(this.ccmodel?.length - this.dynamicItemCount, 0);

                        if (index < this.dynamicItemCount) {
                            content = (
                                <span>
                                    {index === 0 ? null : <span>, </span>}
                                    {this.getNameOrValue(this.nameField, item)}
                                    {extraCount > 0 && isLastIndex ? <span>, +{extraCount} {this.Translate("selected")}</span> : null}
                                    {parent.isFocused && isLastIndex ? <span> -&nbsp;</span> : null }
                                </span>
                            );
                        }
                    }
                    else {
                        if (index === 0) {
                            content = (
                                <span>{this.ccmodel?.length} <translation-container context={this} value={"selected"}/> {parent.isFocused ? <span>&nbsp;-&nbsp;</span> : null }</span>
                            );
                        }
                    }

                    return content;
                }
            }

            let slots = [];

            if(!this.hideLabelSlot){
                slots.push(<span slot="label">{this.$slots.label}</span>);
            }

            const prepend = [];

            if (this.selectionLimit !== 1 && (this.showCheckAll || this.showUncheckAll))
                slots.push(
                    <div slot="prepend-item">
                        <v-list-item
                            ripple
                            on-click={this.toggleAll}
                        >
                            <v-list-item-action>
                                <v-icon color={this.ccmodel?.length > 0 ? 'primary' : ''}>
                                    {this.selectAllIcon}
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {this.allSelected ? <translation-container context={this} value={"Unselect all"}/> : <translation-container context={this} value={"Select all"}/>}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                    </div>);

            if (this.includeEmpty)
                slots.push(
                    <div slot="prepend-item">
                        <v-list-item
                            disabled={this.ccmodel?.length == 0}
                            ripple
                            class={{ 'v-list-item--link': true, 'primary--text': this.emptySelected, 'v-list-item--active': this.emptySelected }}
                            on-click={() => { this.emptySelected = !this.emptySelected; this.$emit('empty', this.emptySelected); }}
                        >
                            <v-list-item-action>
                                <v-icon color={this.ccmodel?.length > 0 ? 'primary' : ''}>
                                    {this.emptySelected ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <translation-container context={this} value={this.emptyLabel || '[ Blank ]'} />
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </div>
                );

            return (
                <v-autocomplete
                    dense
                    outlined
                    item-text={this.nameField}
                    item-value={this.valueField}
                    items={this.source}
                    on-input={(val) => this.onInput(val)}
                    value={this.selectionLimit === 1 && Array.isArray(this.ccmodel) ? this.ccmodel[0] : this.ccmodel}
                    placeholder={this.placeholder}
                    persistent-placeholder
                    multiple={this.selectionLimit !== 1}
                    scopedSlots={scopedSlots}
                    hide-details={this.hideDetails}
                    hint={this.hint}
                    label={this.label}
                    ref={this.uniqueref}
                    rules={this.rules}
                    error-messages={this.errorMessages}
                    error={this.error}
                >
                    {/* We have one button to toggle the check all, so we will show the button if multiple selection is allowed
                        and either show check all is true or show uncheck all is true */}
                    {slots}
                </v-autocomplete>
            );
        }
        catch (e) {
            utils.error('DropdownMultiSelectBase Render failed', e);
            return <div>DropdownMultiSelectBase Failed to Render {e}</div>;
        }
    }
};